import { render, staticRenderFns } from "./GenerazioneFatturePerLavori.vue?vue&type=template&id=5a2a9d31&scoped=true&"
import script from "./GenerazioneFatturePerLavori.vue?vue&type=script&lang=js&"
export * from "./GenerazioneFatturePerLavori.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a9d31",
  null
  
)

export default component.exports